<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content style="max-height: 90vh; display: flex; justify-content: center; background-color:black;">
  <div id="container" class="container" [style.transform]="containerTransform" style="width: 90vh; max-height: 90vh; margin:5vw;">
    <lib-ngx-image-zoom style="max-height: 100%; max-width: 100%;"
                        [thumbImage]=data.imageData
                        [magnification]="1"
                        [enableScrollZoom]="true"
                        zoomMode="hover-freeze"
                        [enableLens]="false"
                        [maxZoomRatio]="3">
    </lib-ngx-image-zoom>
  </div>

  <div class="loader" *ngIf="loading">
    <div class="message">{{ loadingMessageKey | translate : loadingMessageDefault }}</div>
    <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;" *ngIf="loading"></mat-progress-bar>
  </div>

</mat-dialog-content>

<button mat-mini-fab (click)="rotateContainer()" color="primary" style="position: absolute; right: 50%; bottom: 30px; "><mat-icon>rotate_right</mat-icon></button>

<mat-dialog-actions *ngIf="false">
  <div class="col-12" style="text-align: right; padding-left: 5px; padding-right: 5px;">
    <button mat-flat-button color="primary" style="margin: 3px;" (click)="close()" [disabled]="loading">{{ 'Turbo.Service.CreateServiceRequestDialog.Save' | translate : 'Save' }}</button>
  </div>
</mat-dialog-actions>
